/**
* Accordion
*/

import $ from 'jquery';

// Cached elements
const $el = {
	accordion: $('.js-accordion'),
	accordionButton: $('.js-accordion-button'),
	accordionContent: $('.js-accordion-content')
};

const vars = {
	keepOthersOpen: !!$el.accordion.hasClass('js-accordion-keep-others-open')
};

// Module events
export default function init() {
	bindEvents();
}

// User interactions go here
function bindEvents() {
	$el.accordionButton.on('click', doAccordion); 
}

function doAccordion(e) {
	e.preventDefault();
	
	const $this = $(this);
	const $allPanels = $this.closest($el.accordion).find($el.accordionContent);
	const $allButtons = $this.closest($el.accordion).find($el.accordionButton);
	const $accordionContent = $this.closest('li').find($el.accordionContent);
	const $toggleText = $this.find('.js-accordion-text-swap');
	const $allToggleText = $allButtons.find('.js-accordion-text-swap');
	
	
	// Add/remove open classes
	if (!vars.keepOthersOpen) {
		$allButtons.removeClass('is-active');
	}
	
	$this.addClass('is-active');
	
	if ($accordionContent.is(':visible')) {
		$accordionContent.slideUp({
			easing: 'easeInOutQuart'
		});
		$this.removeClass('is-active');
		
		// Change the button text
		$toggleText.text($toggleText.data('text-original'));
	} else {
		
		if (!vars.keepOthersOpen) {
			$allPanels.slideUp({
				easing: 'easeInOutQuart'
			});
			$allToggleText.text($toggleText.data('text-original'));
		}
		
		$accordionContent.slideDown({
			easing: 'easeInOutQuart'
		});
		
		// Change the button text
		$toggleText.text($toggleText.data('text-swap'));
	}
}
